/* import components */
import Card from 'react-bootstrap/Card';
import BadgeFill from './BadgeFill';
import ChevronRight from './icons/ChevronRight';

/* import services */
import { getDateTime, getFirstLetterCapital } from '../utils/utils';

const IssueCard = (props) => {

    return (
        <>
            <Card className="trip-card">
                <div style={{ display: "flex", justifyContent: "space-between", padding: "0" }}>
                    <div style={{ display: "flex"}}>
                        <div>
                            <Card.Title 
                                className="grey font-bold topicOptions">
                                    {props.issue.subject}
                            </Card.Title>
                            <Card.Subtitle className="grey topics">
                                {getDateTime(props.issue.createdAt, "unix")}
                            </Card.Subtitle>
                        </div>
                    </div>
                    <div style={{ display: "flex", marginTop: "auto", marginBottom: "auto" }}>
                        {props.issue.status === 'closed' ? 
                            <BadgeFill type="ticket" title={getFirstLetterCapital(props.issue.status)} />
                            : <></>}
                        <ChevronRight size="16" fill="#6D7278"/>
                    </div>
                </div>
            </Card>
        </>
    );
}

export default IssueCard;